import React from 'react';

const SocialMediaComponent = () => {
  return (
    <div>
        <a href="https://www.facebook.com/DeliveranceChurchUtawala/" target="_blank" class="facebook" rel="noreferrer"><i class="fa-brands fa-facebook"> WATCH ON FACEBOOK</i></a><br />
          <a href="http://www.youtube.com/@DCUtawala"target="_blank" class="youtube" rel="noreferrer"><i class="fa-brands fa-youtube"> WATCH ON YOUTUBE</i></a>
    </div>
  );
};

export default SocialMediaComponent;
